import { baseEndocrineSchema } from '../validations/shared/endocrine';
const shape = baseEndocrineSchema.shape;
export const bgFields = [
    { key: 'bgReading', field: shape.bgReading },
    { key: 'bgTiming', field: shape.bgTiming },
    { key: 'glucoseTrend', field: shape.glucoseTrend },
];
export const glycemiaFields = [
    { key: 'hypoglycemiaEpisode', field: shape.hypoglycemiaEpisode },
    { key: 'hyperglycemiaEpisode', field: shape.hyperglycemiaEpisode },
    { key: 'ssHyperglycemia', field: shape.ssHyperglycemia, variant: 'tags' },
    { key: 'ssHypoglycemia', field: shape.ssHypoglycemia, variant: 'tags' },
];
export const leftFootFields = [
    { key: 'leftSkinIntegrity', field: shape.leftSkinIntegrity },
    { key: 'leftSensation', field: shape.leftSensation },
    { key: 'leftNails', field: shape.leftNails },
];
export const rightFootFields = [
    { key: 'rightSkinIntegrity', field: shape.rightSkinIntegrity },
    { key: 'rightSensation', field: shape.rightSensation },
    { key: 'rightNails', field: shape.rightNails },
];
export const managementFields = [
    { key: 'diabeticMgmt', field: shape.diabeticMgmt, variant: 'tags' },
    { key: 'insulinAdminBy', field: shape.insulinAdminBy, variant: 'tags' },
];
export const endocrineNarrativeFields = [
    { key: 'changeFromLastVisit', field: shape.changeFromLastVisit },
    { key: 'narrative', field: shape.narrative },
];
